// extracted by mini-css-extract-plugin
export default {"heading_container":"Heading_heading_container__YMG3M","heading":"Heading_heading__Hb-ro"};